<rt-dialog-body variant="white">
  <div class="content-container" layout>
    <div class="left">
      <rt-heading variant="large-x-dialog-header bold dark" margin-bottom-large-x>
        <div>
          <span>{{ 'tlc.members.journeys_promo_dialog.heading' | translate }}</span
          >&nbsp;
          <span
            [innerHTML]="'tlc.members.journeys_promo_dialog.journeys' | translate"
            text-primary
          ></span>
        </div>
      </rt-heading>

      <rt-feature-discovery-stepper [steps]="steps" />

      <a class="link-wrapper" [href]="learnMoreLink" target="_blank" margin-top>
        <rt-icon name="open-in-new" colorToken="colorIconPrimaryDefault" />
        <span>{{ 'tlc.members.journeys_promo_dialog.learn_more' | translate }}</span>
      </a>
    </div>
    <div class="right">
      <img
        class="promo-illustration"
        ngSrc="assets/images/tellent/journeys-promo-illustration.png"
        [alt]="'tlc.members.journeys_promo_dialog.illustration_alt' | translate"
        width="370"
        height="450"
      />
    </div>
  </div>
</rt-dialog-body>
<rt-dialog-footer [hasOptionalActions]="true" innerPadding="small">
  <div class="optional">
    <rt-checkbox [formControl]="dontShowAgainControl" class="dont-show-again-checkbox">
      {{ 'tlc.members.journeys_promo_dialog.dont_show_again' | translate }}
    </rt-checkbox>
  </div>
  <rt-button variant="plain" (click)="cancel()">{{ 'tlc.common.cancel' | translate }}</rt-button>
  <rt-button variant="primary" (click)="continue()">
    <span>{{ 'tlc.common.continue' | translate }}</span>
    <rt-icon name="keyboard-arrow-right" />
  </rt-button>
</rt-dialog-footer>
